import "./axios.js";

const TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const USERNAME = "user";
const EMAIL = "email";
const KEY = "key";
const PHOTO = "img";
var CryptoJS = require("crypto-js");
const TYPE_USER = "type";
const TokenService = {
  getToken() {
    return JSON.parse(localStorage.getItem(TOKEN_KEY));
  },
  getUserInfo() {
    return localStorage.getItem(USERNAME);
  },
  getTypeUser() {
    return localStorage.getItem(TYPE_USER);
  },
  getEmailInfo() {
    return localStorage.getItem(EMAIL);
  },
  getKeyInfo() {
    return localStorage.getItem(KEY);
  },
  getPhotoInfo() {
    return localStorage.getItem(PHOTO);
  },
  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },
  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },
  getRefreshToken() {
    return JSON.parse(localStorage.getItem(REFRESH_TOKEN_KEY));
  },
  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },
  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
  saveUserInfo(payload) {
    localStorage.setItem(KEY, payload.id);
    localStorage.setItem(TYPE_USER, payload.type);
    localStorage.setItem(
      USERNAME,
      CryptoJS.AES.encrypt(payload.nickname, payload.id).toString()
    );
    localStorage.setItem(
      EMAIL,
      CryptoJS.AES.encrypt(payload.email, payload.id).toString()
    );
  },
  savePhotoInfo(payload) {
    localStorage.setItem(
      PHOTO,
      CryptoJS.AES.encrypt(payload, this.getKeyInfo()).toString()
    );
  },
  removeInfo() {
    localStorage.removeItem(KEY);
    localStorage.removeItem(USERNAME);
    localStorage.removeItem(EMAIL);
    localStorage.removeItem(PHOTO);
    localStorage.removeItem(TYPE_USER);
  }
};

export { TokenService };
